import { render, staticRenderFns } from "./BasicInfoContent.vue?vue&type=template&id=6f1b991e&scoped=true&"
import script from "./BasicInfoContent.vue?vue&type=script&lang=js&"
export * from "./BasicInfoContent.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoContent.vue?vue&type=style&index=0&id=6f1b991e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1b991e",
  null
  
)

export default component.exports